import { qbHttp } from "./http";

export const listLocations = (params = {}) =>
  qbHttp.request("api/qb/locations", { query: params });

export const getLocation = (id) => qbHttp.request(`api/qb/locations/${id}`);

export const createLocation = (body) =>
  qbHttp.request("api/qb/locations", { method: "POST", body });

export const updateLocation = (id, body) =>
  qbHttp.request(`api/qb/locations/${id}`, { method: "PUT", body });

export const deleteLocation = (id) =>
  qbHttp.request(`api/qb/locations/${id}`, { method: "DELETE" });
